import colors from './colors.theme'

export default {
  baseStyle: {
    color: colors.black
  }
}
